import { browserName, browserVersion, osName, osVersion } from 'react-device-detect';
import HelperVersion from 'utils/helper-version'

export const deviceInformation = () => {
	return {
		deviceBrand: osName,
		deviceName: osVersion,
		platform: browserName,
		platformVersion: browserVersion,
		appVersion: 'web',
		buildVersion: HelperVersion.getBuildVersion(),
	}
}
